export default __webpack_public_path__ + "static/media/cablered.001afc29.png";